<template>
  <div v-if="copy">
    <h1>Email panel</h1>
    <v-btn :to="{ name: 'emailPanelsSales' }"
      ><v-icon>chevron_left</v-icon> Email panels</v-btn
    >
    <v-form ref="formEmailPanel" v-model="valid" lazy-validation>
      <v-text-field
        label="Id"
        v-model="copy.id"
        outline
        readonly
        v-if="$route.params.id"
      />
      <v-text-field label="Heading" v-model="copy.heading" outline />
      <v-text-field label="subheading" v-model="copy.subheading" outline />
      <v-input label="Background colour">
        <v-swatches v-model="copy.background" />
      </v-input>
      <v-input label="Text colour">
        <v-swatches v-model="copy.colour" />
      </v-input>
      <v-select
        item-text="name"
        item-value="id"
        v-model="copy.button"
        :items="buttons"
        label="Button"
        outline
      />
      <v-btn @click="saveEmailPanel">Save</v-btn>
    </v-form>
    <EmailPanelZ :value="copy" />
  </div>
</template>

<script>
import EmailPanelZ from "@/components/quote/emailPanel/EmailPanel";
import VSwatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.css";
import nbmlaw from "@/api/nbmlaw";
import { buttonList } from "@/util/helpers";
export default {
  name: "EmailPanel",
  metaInfo() {
    return {
      title: "Email Panel",
      titleTemplate: "%s - Sales - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: {
    EmailPanelZ,
    VSwatches
  },
  data() {
    return {
      emailPanel: null,
      copy: null,
      valid: false,
      buttons: null
    };
  },
  methods: {
    async fetchEmailPanel() {
      const response = await nbmlaw.get(
        `/cors/admin/sales/emailPanels/${this.$route.params.id}`
      );
      // console.log(response.data);
      this.emailPanel = response.data;
    },
    saveEmailPanel() {
      if (this.$refs.formEmailPanel.validate()) {
        if (this.$route.params.id) {
          this.updateEmailPanel();
        } else {
          this.createEmailPanel();
        }
      }
    },
    async createEmailPanel() {
      await nbmlaw.post(`/cors/admin/sales/emailPanels`, this.copy);
      this.$router.push({ name: "emailPanelsSales" });
    },
    async updateEmailPanel() {
      await nbmlaw.put(
        `/cors/admin/sales/emailPanels/${this.$route.params.id}`,
        this.copy
      );
      this.$router.push({ name: "emailPanelsSales" });
    }
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        if (this.$route.params.id) {
          this.fetchEmailPanel();
        } else {
          this.copy = {
            heading: "NEW HEADING",
            subheading: "NEW SUBHEADING",
            background: "#000000",
            colour: "#000000",
            button: 0
          };
        }
      }
    },
    emailPanel: {
      handler() {
        if (this.emailPanel) {
          this.copy = JSON.parse(JSON.stringify(this.emailPanel));
        }
      }
    }
  },
  created() {
    this.buttons = buttonList();
  }
};
</script>